import gql from 'graphql-tag';

export const GET_REFEREE_REPORT_STATUS = gql`
  query ($formId: ID!) {
    getRefereeFormStatus(formId: $formId)
  }
`;
